import React from "react";
import { DynamicSlider } from "../DynamicSlider";

export const Sliders = () => {
  return (
    <DynamicSlider section="Home" subSection="Carrusel 1" />
  );
};
